import React from "react";
import { NavLink, Outlet, useParams, useLocation } from "react-router-dom";
import "./specificCustomer.scss";

function SpecificCustomer() {
  const { clientName,clientID } = useParams();
  const location = useLocation();
  
  return (
    <div className="customers-container">
      <div className="customer-navbar">
        <NavLink to="tas" className={({ isActive }) => isActive ? "nav-active" : "nav-link"}>
          TAs
        </NavLink>

        <NavLink to="barred" className={({ isActive }) => isActive ? "nav-active" : "nav-link"}>
          Barred Companies
        </NavLink>
      </div>
      <Outlet context={{ clientID, clientName }} />
    </div>
  );
}

export default SpecificCustomer;